import React from 'react';
import { graphql, navigate } from 'gatsby';
import { PatchNoteListItem } from '../components/patch-notes/patch-note-list-item';
import { Pagination } from '../components/pagination/pagination';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { patchNotePath } from '../util/path-generator';
import { FadeInAnimation } from '../style/animations';
import styled from 'styled-components';
import { Grid } from '../style/layout';

const PatchNoteListWrapper = styled(Grid)`
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  margin: 16px 0;
`;

const PatchNoteList = ({
  data: { allContentfulAppPatchNote },
  pageContext,
}) => {
  const handleClick = patchNumber => {
    const path = patchNotePath(patchNumber);
    navigate(path, {
      state: { backButton: true },
    });
  };

  // accessability functionality, making the divs tabbable
  const handleKeyPress = (e, patchNumber) => {
    e.preventDefault();
    if (e.code === 'Space' || e.code === 'Enter') {
      e.stopPropagation();
      handleClick(patchNumber);
    }
  };

  return (
    <Layout>
      <SEO title="Patch notes" />
      <PatchNoteListWrapper>
        {allContentfulAppPatchNote.edges.map(({ node }, index) => (
          <FadeInAnimation
            direction="up"
            duration="0.4s"
            delay={index * 0.16 + 's'}
            key={index}
            onClick={ev => {
              ev.preventDefault();
              handleClick(node.patchNumber);
            }}
            role="button"
            tabIndex="0"
            onKeyPress={e => handleKeyPress(e, node.patchNumber)}
            style={{ cursor: 'pointer' }}
          >
            <PatchNoteListItem data={node} />
          </FadeInAnimation>
        ))}
      </PatchNoteListWrapper>
      <Pagination {...pageContext} />
    </Layout>
  );
};

export const query = graphql`
  query GetPatchNotes($limit: Int = 10, $skip: Int = 0) {
    allContentfulAppPatchNote(
      limit: $limit
      skip: $skip
      sort: { order: DESC, fields: patchDate }
    ) {
      totalCount
      edges {
        node {
          patchNumber
          patchNotesSummary {
            childMarkdownRemark {
              html
            }
          }
          patchDate
          image {
            fluid(maxWidth: 1920) {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`;

export default PatchNoteList;
